import axios from "axios";

export const apiGetJobSchedulingList = (data) => {
  return axios.get(`/api/Jobbing/schedule`, { params: data }).then((result) => {
    if (result) {
      if (result.data) {
        result.data.scheduledJobs?.map((item) => {
          item.companyName =
            item.companyName === "-PLACEHOLDER-" ? "" : item.companyName;
          item.resourceId = item.technicianEmail
            ? item.technicianEmail
            : "Unassigned";
          item.start = item.dueDateTime;
          item.end = item.scheduledEndDateTime;
          item.title = item.jobNumber;
          item.color =
            item.jobStatusId === 1
              ? "#ff8f8f"
              : item.jobStatusId === 2
              ? "#ffdda6"
              : item.jobStatusId === 4
              ? "#71a8d2"
              : item.jobStatusId === 0 || item.jobStatusId === 5
              ? "#ced4db"
              : "#c4f8c8";
          if (
            typeof item.start === "string" &&
            !item.start.match(/^\d{4}-\d{2}-\d{2}$/) && // Not date-only (allDay)
            !item.start.match(/[+-]\d{2}:\d{2}$/) && // No existing offset (+HH:mm or -HH:mm)
            !item.start.endsWith("Z")
          ) {
            // No existing 'Z'
            item.start += "Z";
          }
          if (
            typeof item.end === "string" &&
            !item.end.match(/^\d{4}-\d{2}-\d{2}$/) && // Not date-only (allDay)
            !item.end.match(/[+-]\d{2}:\d{2}$/) && // No existing offset (+HH:mm or -HH:mm)
            !item.end.endsWith("Z")
          ) {
            // No existing 'Z'
            item.end += "Z";
          }
        });
        result.data.unscheduledJobs?.map((item) => {
          item.companyName =
            item.companyName === "-PLACEHOLDER-" ? "" : item.companyName;
          item.resourceId = item.technicianEmail
            ? item.technicianEmail
            : "Unassigned";
          item.start = item.dueDateTime;
          item.end = item.scheduledEndDateTime;
          item.title = item.jobNumber;
          item.color =
            item.jobStatusId === 1
              ? "#ff8f8f"
              : item.jobStatusId === 2
              ? "#ffdda6"
              : item.jobStatusId === 4
              ? "#71a8d2"
              : item.jobStatusId === 0 || item.jobStatusId === 5
              ? "#ced4db"
              : "#c4f8c8";
        });
        const eventsData = result.data.scheduledJobs;
        const eventsWithToday = ensureTodayEvent(eventsData);
        const updatedEvents = eventsWithToday.map((event) => {
          if (event.end && event.start !== event.end) {
            return { ...event, end: event.start };
          }
          return event;
        });
        result.data.agendaEvents = updatedEvents;
        return result.data;
      }
    }
    return false;
  });
};

export const apiGetTechnicianList = () => {
  return axios.get("/api/user/my-users-with-current").then((result) => {
    if (result) {
      if (result.data) {
        result.data.sort((a, b) => a.fullName.localeCompare(b.fullName));
        result.data.map((item) => {
          item.value = item.email;
          item.text = item.fullName;
          item.id = item.email;
          item.title = getTechInitials(item.fullName);
        });
        let filteredItems = result.data.filter((item) => item.isAccepted);
        filteredItems.push({
          text: "Unassigned",
          value: "Unassigned",
          id: "Unassigned",
          title: "Unassigned",
        });
        const userIndex = filteredItems.findIndex(
          (obj) => obj.email === localStorage.getItem("user")
        );
        if (userIndex > -1) {
          const [foundObject] = filteredItems.splice(userIndex, 1);
          filteredItems.unshift(foundObject);
        }
        console.log(filteredItems);
        return filteredItems;
      }
    }
    return false;
  });
};

export const apiScheduleJob = async (data) => {
  console.log(data);
  const payload = {
    technicianEmail: data.resourceId === "Unassigned" ? null : data.resourceId,
    dueDateTime: data.start ? data.start : null,
    scheduledEndDateTime: data.end ? data.end : null,
    customerLocation: data.extendedProps?.customerLocation,
  };
  return axios
    .put(`/api/Jobbing/schedule/${data.id}`, payload)
    .then((result) => {
      if (result && result.data) {
        result.data.scheduledJobs?.map((item) => {
          item.companyName =
            item.companyName === "-PLACEHOLDER-" ? "" : item.companyName;
          item.resourceId = item.technicianEmail
            ? item.technicianEmail
            : "Unassigned";
          item.start = item.dueDateTime;
          item.end = item.scheduledEndDateTime;
          item.title = item.jobNumber;
          item.color =
            item.jobStatusId === 1
              ? "#ff8f8f"
              : item.jobStatusId === 2
              ? "#ffdda6"
              : item.jobStatusId === 4
              ? "#71a8d2"
              : item.jobStatusId === 0 || item.jobStatusId === 5
              ? "#ced4db"
              : "#c4f8c8";
          if (
            typeof item.start === "string" &&
            !item.start.match(/^\d{4}-\d{2}-\d{2}$/) && // Not date-only (allDay)
            !item.start.match(/[+-]\d{2}:\d{2}$/) && // No existing offset (+HH:mm or -HH:mm)
            !item.start.endsWith("Z")
          ) {
            // No existing 'Z'
            item.start += "Z";
          }
          if (
            typeof item.end === "string" &&
            !item.end.match(/^\d{4}-\d{2}-\d{2}$/) && // Not date-only (allDay)
            !item.end.match(/[+-]\d{2}:\d{2}$/) && // No existing offset (+HH:mm or -HH:mm)
            !item.end.endsWith("Z")
          ) {
            // No existing 'Z'
            item.end += "Z";
          }
        });
        result.data.unscheduledJobs?.map((item) => {
          item.companyName =
            item.companyName === "-PLACEHOLDER-" ? "" : item.companyName;
          item.resourceId = item.technicianEmail
            ? item.technicianEmail
            : "Unassigned";
          item.start = item.dueDateTime;
          item.end = item.scheduledEndDateTime;
          item.title = item.jobNumber;
          item.color =
            item.jobStatusId === 1
              ? "#ff8f8f"
              : item.jobStatusId === 2
              ? "#ffdda6"
              : item.jobStatusId === 4
              ? "#71a8d2"
              : item.jobStatusId === 0 || item.jobStatusId === 5
              ? "#ced4db"
              : "#c4f8c8";
        });
        return result.data;
      }
      return false;
    })
    .catch((error) => {
      // Handle error response
      if (error.response.data) {
        const data = error.response.data;
        showErrorToast(data?.description);
        return false;
      } else {
        console.log("Error:", error.message);
      }
      return false;
    });
};

function getTechInitials(fullName) {
  if (fullName.toLowerCase() === "unassigned") {
    return "Unassigned";
  } else {
    const names = fullName.trim().split(/\s+/);
    if (names.length === 0) return "";
    const firstName = names[0];
    const lastNameInitial =
      names.length > 1 ? ` ${names[names.length - 1][0]}` : "";
    return firstName + lastNameInitial;
  }
}

function ensureTodayEvent(eventsList) {
  const today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const day = today.getDate().toString().padStart(2, "0");

  const todayIsoDate = `${year}-${month}-${day}`;

  const hasEventToday = eventsList.some((event) => {
    const eventDate = new Date(event.start);
    const year = eventDate.getFullYear();
    const month = (eventDate.getMonth() + 1).toString().padStart(2, "0");
    const day = eventDate.getDate().toString().padStart(2, "0");

    const eventUtcIsoDate = `${year}-${month}-${day}`;
    return eventUtcIsoDate === todayIsoDate;
  });

  if (!hasEventToday) {
    const newEvent = {
      id: "0",
      jobNumber: "N/A",
      companyName: "No Events Today",
      customerLocation: "",
      jobStatusId: null,
      technicianEmail: null,
      technicianName: "",
      resourceId: null,
      start: todayIsoDate,
      end: todayIsoDate,
      title: "No events scheduled for today",
      color: "#cccccc",
    };
    eventsList.push(newEvent);
  } else {
    console.log("Events for today already exist.");
  }
  return eventsList;
}
